var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback, useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Modal, Button, TextArea, TextField, KeyValue, MessageBanner, } from "@folio/stripes/components";
import { useIntl, FormattedMessage } from "react-intl";
import { createIrregularIssue } from "../../api/periodicalIssueService";
import { extractServerErrorMessage } from "../../utils/errorHandler";
import { MAX_ISSUE_NUMBER } from "../../utils/issueNumber";
import { useIssueNumberInput } from "../../hooks/useIssueNumberInput";
import { useIssueVolumeChoice } from "../../hooks/useIssueVolumeChoice";
import { invalidateVolumeViews } from "../../hooks/usePeriodicalVolumes";
import { invalidateDepositRecordViews } from "../../utils/depositRecordQueries";
import { fetchNextIssueNumber } from "../../api/periodicalCheckService";
import { IssueVolumeRow } from "./IssueVolumeRow";
import { IssueNumberingHint } from "./IssueNumberingHint";
export var AddIrregularIssueDialog = function (_a) {
    var periodicalLibraryId = _a.periodicalLibraryId, settings = _a.settings, volumes = _a.volumes, open = _a.open, numberEditable = _a.numberEditable, onClose = _a.onClose, onCreated = _a.onCreated;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var titleId = settings.titleId;
    var _b = useState(""), irregularNote = _b[0], setIrregularNote = _b[1];
    var _c = useState(null), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = useIssueVolumeChoice(open, volumes), volumeId = _d.volumeId, setVolumeId = _d.setVolumeId, requestVolumeId = _d.requestVolumeId;
    useEffect(function () {
        if (!open) {
            setIrregularNote("");
            setErrorMessage(null);
        }
    }, [open]);
    var _e = useQuery(["nextIssueNumber", titleId, volumeId], function () { return fetchNextIssueNumber(kyInstance, titleId, requestVolumeId); }, { enabled: open }), suggestedNumber = _e.data, numberLoading = _e.isLoading;
    var nextIssueNumber = suggestedNumber !== null && suggestedNumber !== void 0 ? suggestedNumber : 1;
    var _f = useIssueNumberInput(open, numberEditable, numberLoading, nextIssueNumber, true), issueNumberInput = _f.issueNumberInput, handleIssueNumberChange = _f.handleIssueNumberChange, isNumberValid = _f.isNumberValid;
    var mutation = useMutation(function (_a) {
        var plId = _a.plId, payload = _a.payload;
        return createIrregularIssue(kyInstance, plId, payload);
    }, {
        onSuccess: function (created) {
            invalidateVolumeViews(queryClient);
            invalidateDepositRecordViews(queryClient);
            queryClient.invalidateQueries(["nextIssueNumber", titleId]);
            onCreated(created.volumeId);
            onClose();
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = setErrorMessage;
                        return [4 /*yield*/, extractServerErrorMessage(error, formatMessage, formatMessage({
                                id: "ui-br-legaldeposits.periodicals.issue.dialog.error",
                            }))];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleConfirm = useCallback(function () {
        if (!isNumberValid)
            return;
        mutation.mutate({
            plId: periodicalLibraryId,
            payload: {
                irregularNote: irregularNote.trim() || undefined,
                volumeId: requestVolumeId,
                issueNumber: numberEditable
                    ? Number(issueNumberInput.trim())
                    : undefined,
            },
        });
    }, [
        irregularNote,
        periodicalLibraryId,
        requestVolumeId,
        isNumberValid,
        numberEditable,
        issueNumberInput,
        mutation,
    ]);
    var handleNoteChange = useCallback(function (e) {
        return setIrregularNote(e.target.value);
    }, []);
    if (!open)
        return null;
    return (React.createElement(Modal, { open: true, label: formatMessage({
            id: "ui-br-legaldeposits.periodicals.action.add-irregular-issue",
        }), onClose: onClose, dismissible: true, footer: React.createElement("div", null,
            React.createElement(Button, { buttonStyle: "primary", onClick: handleConfirm, disabled: !isNumberValid || mutation.isLoading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.confirm" })),
            React.createElement(Button, { onClick: onClose },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" }))) },
        errorMessage && (React.createElement(MessageBanner, { type: "error" }, errorMessage)),
        React.createElement(IssueVolumeRow, { volumes: volumes, value: volumeId, onChange: setVolumeId, disabled: mutation.isLoading }),
        numberEditable ? (React.createElement(TextField, { label: formatMessage({
                id: "ui-br-legaldeposits.periodicals.issue.dialog.issue-number",
            }), value: issueNumberInput, onChange: handleIssueNumberChange, error: isNumberValid
                ? undefined
                : formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.issue-number.error",
                }, { max: MAX_ISSUE_NUMBER }), required: true })) : (React.createElement(KeyValue, { label: formatMessage({
                id: "ui-br-legaldeposits.periodicals.irregular-issue.preview-label",
            }), value: numberLoading ? "…" : String(nextIssueNumber) })),
        React.createElement(IssueNumberingHint, { settings: settings }),
        React.createElement(TextArea, { label: formatMessage({
                id: "ui-br-legaldeposits.periodicals.irregular-issue.note",
            }), value: irregularNote, onChange: handleNoteChange })));
};
